module.exports = __webpack_public_path__ + "img/indexNews.6acfc45e.jpg";